/**
 * api/surveys.ts — `/api/surveys*` endpoints.
 *
 * Carved from `src/stores/useApiStore.ts`. The store owns the
 * variant/journey orchestration; this module is the HTTP shape.
 */

import { apiFetch } from "./client.ts";

export interface SurveyBody {
    [key: string]: unknown;
    status: "partial" | "complete";
    variant?: string;
    journeyId?: string;
    draftId: string;
}

export async function submitSurvey(
    body: SurveyBody,
    headers: Record<string, string>,
): Promise<void> {
    await apiFetch<unknown>("/api/surveys", {
        method: "POST",
        headers,
        body: JSON.stringify(body),
    });
}
